import React from 'react';
import PropTypes from 'prop-types';
import { get } from 'lodash';
import { buildThumbnailUrl } from '@bd/bdcore-utilities';
import { css } from '@bd/bdui-styles/emotion';
import { colors, typography } from '../styles';

const styles = css`
  .InsideHeader_wrapper {
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;
    @media (min-width: 992px) {
      background-image: url('/images/main-image-bg-fpo.jpg');
      background-size: cover;
      background-position: center center;
      height: 520px;
      width: 100%;
      display: flex;
      align-items: flex-end;
      &::after {
        content: '';
        position: absolute;
        z-index: 1;
        top: 0;
        right: 0;
        bottom: 0;
        left: 0;
        background-color: ${colors.black};
        opacity: .3;
      }
    }
    &-noImage {
      @media (min-width: 992px) {
        height: 260px;
        background-color: ${colors.brand1};
        &::after {
          display: none;
        }
      }
    }
  }
  .InsideHeader_titleWrapper {
    width: 100%;
    display: flex;
    align-items: center;
    background-color: ${colors.brand1};
    padding: 65px 0 0 0;
    color: white;
    height: 130px;
    @media (min-width: 992px) {
      width: 100%;
      height: 120px;
      padding: 0;
      position: relative;
      background-color: transparent;
      &::after {
        content: '';
        display: block;
        position: absolute;
        left: 0;
        right: 0;
        top: 0;
        bottom: 0;
        background-color: ${colors.brand2Dark};
        opacity: .85;
        z-index: 0;
      }
    }
  }
  .InsideHeader_title {
    margin: 0;
    text-align: center;
    font-size: 24px;
    font-family: ${typography.Serif};
    @media (min-width: 992px) {
      font-size: 40px;
      z-index: 2;
      position: relative;
      color: ${colors.white};
    }
    span {
      font-size: 14px;
      font-weight: 700;
      display: block;
      margin: 0 auto;
      font-family: ${typography.SansSerif};
      text-transform: uppercase;
      letter-spacing: 2px;
      @media (min-width: 992px) {
        font-size: 16px;
      }
    }
  }
`;

function InsideHeader({ page, heading, subheading }) {
  const mediaStyle = {};
  if (get(page, 'page_image.contentUrl')) {
    mediaStyle.backgroundImage = `url('${buildThumbnailUrl(get(page, 'page_image.contentUrl'), { width: 2000, height: 2000 })}')`;
  }
  return (
    <div className={styles}>
      {
        !get(page, 'hide_header_image') &&
        <div className="InsideHeader_wrapper" style={mediaStyle}>
          <div className="InsideHeader_titleWrapper">
            <div className="container-fluid">
              <h1 className="InsideHeader_title">
                {heading}
                <span>{subheading}</span>
              </h1>
            </div>
          </div>
        </div>
      }
      {
        get(page, 'hide_header_image') &&
        <div className="InsideHeader_wrapper InsideHeader_wrapper-noImage">
          <div className="InsideHeader_titleWrapper">
            <div className="container-fluid">
              <h1 className="InsideHeader_title">
                {heading}
                <span>{subheading}</span>
              </h1>
            </div>
          </div>
        </div>
      }
    </div>
  );
}

InsideHeader.propTypes = {
  page: PropTypes.object.isRequired,
  heading: PropTypes.string,
  subheading: PropTypes.string,
};

InsideHeader.defaultProps = {
  page: undefined,
  heading: undefined,
  subheading: undefined,
};

export default InsideHeader;



// WEBPACK FOOTER //
// ./src/components/InsideHeader.js